import { HTTPError } from 'ky';
import { TempoApiError } from '@/common/api/tempoApiTypes';

export const extractServerMessage = async (error: unknown): Promise<string | null> => {
  if (!(error instanceof HTTPError)) {
    return null;
  }
  // TempoApiError is constructed manually in the afterResponse hook, bypassing ky's own
  // body-consuming HTTPError flow, so `error.data` is never populated for it - re-read the
  // (still-unconsumed) response instead.
  try {
    const body = (
      error instanceof TempoApiError ? await error.response.clone().json() : error.data
    ) as { message?: unknown } | undefined;
    return typeof body?.message === 'string' && body.message.trim().length > 0
      ? body.message
      : null;
  } catch {
    return null;
  }
};
